import { useParams } from 'react-router';

import Ocu3SsSingleCard from '@/features/engineoil/card/workshop/Ocu3SsSingleCard';
import Tbm3DidCard from '@/features/engineoil/card/workshop/Tbm3DidCard';
import Tbm3SsSeriesCard from '@/features/engineoil/card/workshop/Tbm3SsSeriesCard';
import Tbm3SsSingleCard from '@/features/engineoil/card/workshop/Tbm3SsSingleCard';
import { SOURCE_DEVICE, SOURCE_TYPE } from '@/features/engineoil/utils/constants';
import { useGetEngineOilQuery } from '@/services/api';
import CardSkeletonScreen from './CardSkeletonScreen';
import Cm4SsSeriesCard from './Cm4SsSeriesCard';
import NoDataCard from './NoDataCard';

const WorkshopCard = () => {
    const { assetId } = useParams<{ assetId: string }>();
    const { data: engineOil, isLoading, error } = useGetEngineOilQuery(assetId!);

    if (isLoading) {
        return <CardSkeletonScreen />;
    }

    if (error || !engineOil) {
        return <NoDataCard />;
    }

    switch (engineOil.source_device) {
        case SOURCE_DEVICE.CM4:
            switch (engineOil.source_type) {
                case SOURCE_TYPE.SENSOR_SIGNAL_SERIES:
                    return <Cm4SsSeriesCard engineOil={engineOil} />;
                case SOURCE_TYPE.DID:
                    return null;
                default:
                    return null;
            }
        case SOURCE_DEVICE.TBM3:
            switch (engineOil.source_type) {
                case SOURCE_TYPE.SENSOR_SIGNAL_SERIES:
                    return <Tbm3SsSeriesCard engineOil={engineOil} />;
                case SOURCE_TYPE.SENSOR_SIGNAL_SINGLE:
                    return <Tbm3SsSingleCard engineOil={engineOil} />;
                case SOURCE_TYPE.DID:
                    return <Tbm3DidCard engineOil={engineOil} />;
                default:
                    return null;
            }
        case SOURCE_DEVICE.OCU3:
            switch (engineOil.source_type) {
                case SOURCE_TYPE.SENSOR_SIGNAL_SINGLE:
                    return <Ocu3SsSingleCard engineOil={engineOil} />;
                default:
                    return null;
            }
        default:
            return null;
    }
};

export default WorkshopCard;
